// extracted by mini-css-extract-plugin
export var content = "_bl-3";
export var list = "_bl-4";
export var settingsContent = "_bl-7";
export var settingsPanel = "_bl-8";
export var state = "_bl-6";
export var triggerBadge = "_bl-2";
export var triggerButton = "_bl-1";
export var triggerShell = "_bl-0";
export var unreadDot = "_bl-5";